export const markAsRead = (
    conversationId,
    messageIds,
    user,
    ws
) => {
    const uniqueMessageIds = [...new Set(messageIds)];
    ws.current.emit('markAsRead', { conversationId, userId: user._id, messageIds: uniqueMessageIds });
};